import type { IConfig } from './configEnv.interface';

import { configEnvCode } from './configEnv.code';
import { configEnvDev } from './configEnv.dev';
import { configEnvProd } from './configEnv.prod';

// Same three-profile pattern as busLineApp/environment/configEnv.ts, but read
// from `import.meta.env.VITE_APP_ENV` — Vite only exposes VITE_-prefixed vars to
// client code, and it inlines them at build time, so the profile is baked into
// each `npm run build:*` artifact.
const resolveConfig = (): IConfig => {
    const appEnv = import.meta.env.VITE_APP_ENV;

    if (appEnv === 'production' || appEnv === 'prod') {
        return configEnvProd;
    }
    if (appEnv === 'development' || appEnv === 'dev') {
        return configEnvDev;
    }
    // 'coding' / 'code' / anything unset
    return configEnvCode;
};

export const config: IConfig = resolveConfig();

// Injected by vite.config.ts from package.json. Shown in the footer.
//
// Unlike busLineApp and busLineSrv this version is NOT a gate: the API only
// checks AppVersion on POST /login (see busLineApi resolveVersionGate), and this
// site never logs anyone in. 'web' is a valid AppName with its own
// min_required_version_web row in AppConfig, but nothing here can trip it, so no
// release runbook step comes with a version bump.
export const APP_VERSION: string = __APP_VERSION__;

if (config.debug.enabled) {
    console.log(`[busLineWeb] env=${config.name} version=${APP_VERSION} api=${config.api.baseUrl}`);
}

export type { IConfig, IApiConfig, IDebugConfig } from './configEnv.interface';
